"use strict";

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAudioInput = exports.createAudioContext = exports.VoiceFocus = void 0;

var decider_js_1 = require("./decider.js");

var fetch_js_1 = require("./fetch.js");

var loader_js_1 = require("./loader.js");

var support_js_1 = require("./support.js");

var worklet_inline_node_js_1 = require("./worklet-inline-node.js");

var worklet_worker_sab_node_js_1 = require("./worklet-worker-sab-node.js");

var worklet_worker_postMessage_node_js_1 = require("./worklet-worker-postMessage-node.js");

var DEFAULT_AGC_DISABLED_SETTING = {
  useVoiceFocusAGC: false,
  useBuiltInAGC: true
};
var DEFAULT_AGC_SETTING = DEFAULT_AGC_DISABLED_SETTING;
var DEFAULT_ASSET_GROUP = 'stable-v1';
var DEFAULT_CDN = 'https://static.sdkassets.chime.aws/';
var DEFAULT_PATHS = {
  processors: "".concat(DEFAULT_CDN, "processors/"),
  workers: "".concat(DEFAULT_CDN, "workers/"),
  wasm: "".concat(DEFAULT_CDN, "wasm/"),
  models: "".concat(DEFAULT_CDN, "wasm/")
};
var DEFAULT_CONTEXT_HINT = {
  latencyHint: 0
};
var BASE_AUDIO_CONSTRAINTS = {
  channelCount: 1,
  echoCancellation: true,
  googEchoCancellation: true,
  noiseSuppression: false,
  googNoiseSuppression: false,
  googHighpassFilter: false,
  googTypingNoiseDetection: false
};
var DEFAULT_AUDIO_CONSTRAINTS_WITH_BUILTIN_AGC = Object.assign(Object.assign({}, BASE_AUDIO_CONSTRAINTS), {
  autoGainControl: true,
  googAutoGainControl: true,
  googAutoGainControl2: true
});
var DEFAULT_AUDIO_CONSTRAINTS_WITHOUT_BUILTIN_AGC = Object.assign(Object.assign({}, BASE_AUDIO_CONSTRAINTS), {
  autoGainControl: false,
  googAutoGainControl: false,
  googAutoGainControl2: false
});
var PROCESSORS = {
  'voicefocus-worker-sab-processor': {
    file: 'worklet-worker-sab-processor-v1.js',
    node: worklet_worker_sab_node_js_1.default
  },
  'voicefocus-worker-postMessage-processor': {
    file: 'worklet-worker-postMessage-processor-v1.js',
    node: worklet_worker_postMessage_node_js_1.default
  },
  'voicefocus-inline-processor': {
    file: 'worklet-inline-processor-v1.js',
    node: worklet_inline_node_js_1.default
  }
};

var validateAssetSpec = function validateAssetSpec(assetGroup, revisionID) {
  if (assetGroup !== undefined && !fetch_js_1.isValidAssetGroup(assetGroup)) {
    throw new Error("Invalid asset group ".concat(assetGroup));
  }

  if (revisionID !== undefined && !fetch_js_1.isValidRevisionID(revisionID)) {
    throw new Error("Invalid revision ID ".concat(revisionID));
  }
};

var mungeConstraints = function mungeConstraints(constraints, agc) {
  var defaultConstraints;

  if (agc.useBuiltInAGC) {
    defaultConstraints = DEFAULT_AUDIO_CONSTRAINTS_WITH_BUILTIN_AGC;
  } else {
    defaultConstraints = DEFAULT_AUDIO_CONSTRAINTS_WITHOUT_BUILTIN_AGC;
  }

  if (!constraints) {
    return {
      audio: defaultConstraints
    };
  }

  if (!constraints.audio) {
    return constraints;
  }

  if (constraints.video) {
    throw new Error('Not adding Voice Focus to multi-device getUserMedia call.');
  }

  return Object.assign(Object.assign({}, constraints), {
    audio: constraints.audio === true ? defaultConstraints : Object.assign(Object.assign({}, constraints.audio), defaultConstraints)
  });
};

var urlForModel = function urlForModel(model, paths) {
  return "".concat(paths.models).concat(decider_js_1.decideModel(model), ".wasm");
};

var VoiceFocus = /*#__PURE__*/function () {
  function VoiceFocus(worker, processorURL, nodeConstructor, nodeOptions, executionQuanta) {
    _classCallCheck(this, VoiceFocus);

    this.processorURL = processorURL;
    this.nodeConstructor = nodeConstructor;
    this.nodeOptions = nodeOptions;
    this.executionQuanta = executionQuanta;
    this.internal = {
      worker: worker,
      nodeOptions: nodeOptions
    };
  }

  _createClass(VoiceFocus, [{
    key: "createNode",
    value: function createNode(context, options) {
      var _this = this;

      var _a;

      var _ref = options || {},
          _ref$voiceFocusSample = _ref.voiceFocusSampleRate,
          voiceFocusSampleRate = _ref$voiceFocusSample === void 0 ? context.sampleRate === 16000 ? 16000 : 48000 : _ref$voiceFocusSample,
          _ref$enabled = _ref.enabled,
          enabled = _ref$enabled === void 0 ? true : _ref$enabled,
          _ref$agc = _ref.agc,
          agc = _ref$agc === void 0 ? DEFAULT_AGC_SETTING : _ref$agc;

      var supportFarendStream = options === null || options === void 0 ? void 0 : options.es;
      var processorOptions = {
        voiceFocusSampleRate: voiceFocusSampleRate,
        enabled: enabled,
        sendBufferCount: 10,
        prefill: 6,
        agc: agc,
        executionQuanta: this.executionQuanta,
        supportFarendStream: supportFarendStream
      };
      var url = fetch_js_1.withQueryString(this.processorURL, (_a = this.nodeOptions) === null || _a === void 0 ? void 0 : _a.fetchBehavior);
      return context.audioWorklet.addModule(url).then(function () {
        return new _this.nodeConstructor(context, Object.assign(Object.assign({}, _this.nodeOptions), {
          processorOptions: processorOptions
        }));
      });
    }
  }, {
    key: "applyToStream",
    value: function applyToStream(stream, context, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var source, node, destination;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                source = context.createMediaStreamSource(stream);
                _context.next = 3;
                return this.applyToSourceNode(source, context, options);

              case 3:
                node = _context.sent;
                destination = context.createMediaStreamDestination();
                node.connect(destination);
                return _context.abrupt("return", {
                  node: node,
                  source: source,
                  destination: destination,
                  stream: destination.stream
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "applyToSourceNode",
    value: function applyToSourceNode(source, context, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var node;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.createNode(context, options);

              case 2:
                node = _context2.sent;
                source.connect(node);
                return _context2.abrupt("return", node);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }], [{
    key: "isSupported",
    value: function isSupported(spec, options) {
      var _ref2 = options || {},
          fetchBehavior = _ref2.fetchBehavior,
          logger = _ref2.logger;

      if (typeof globalThis === 'undefined') {
        logger === null || logger === void 0 ? void 0 : logger.debug('Browser does not have globalThis.');
        return Promise.resolve(false);
      }

      if (!support_js_1.supportsAudioWorklet(globalThis, logger)) {
        logger === null || logger === void 0 ? void 0 : logger.debug('Browser does not support Audio Worklet.');
        return Promise.resolve(false);
      }

      if (!support_js_1.supportsWASM(globalThis, logger)) {
        logger === null || logger === void 0 ? void 0 : logger.debug('Browser does not support WASM.');
        return Promise.resolve(false);
      }

      if (!support_js_1.supportsWASMStreaming(globalThis, logger)) {
        logger === null || logger === void 0 ? void 0 : logger.debug('Browser does not support streaming WASM compilation.');
      }

      var _ref3 = spec || {},
          _ref3$assetGroup = _ref3.assetGroup,
          assetGroup = _ref3$assetGroup === void 0 ? DEFAULT_ASSET_GROUP : _ref3$assetGroup,
          revisionID = _ref3.revisionID,
          _ref3$paths = _ref3.paths,
          paths = _ref3$paths === void 0 ? DEFAULT_PATHS : _ref3$paths;

      validateAssetSpec(assetGroup, revisionID);
      var assetConfig = revisionID ? {
        revisionID: revisionID
      } : {
        assetGroup: assetGroup
      };
      var updatedFetchBehavior = fetch_js_1.addQueryParams(fetchBehavior, assetConfig);
      var fetchConfig = Object.assign(Object.assign({}, updatedFetchBehavior), {
        paths: paths
      });
      return support_js_1.supportsVoiceFocusWorker(globalThis, fetchConfig, logger);
    }
  }, {
    key: "mungeExecutionPreference",
    value: function mungeExecutionPreference(preference, logger) {
      var isAuto = preference === undefined || preference === 'auto';

      if (support_js_1.isSafari(globalThis)) {
        if (isAuto || preference === 'inline') {
          return 'inline';
        }

        if (!isAuto) {
          throw new Error("Unsupported execution preference ".concat(preference));
        }
      }

      if (preference === 'worker-sab' && !support_js_1.supportsSharedArrayBuffer(globalThis, globalThis, logger)) {
        throw new Error("Unsupported execution preference ".concat(preference));
      }

      return preference || 'auto';
    }
  }, {
    key: "configure",
    value: function configure(spec, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _ref4, fetchBehavior, preResolve, logger, _ref5, _ref5$category, category, _ref5$name, name, _ref5$variant, variantPreference, _ref5$assetGroup, assetGroup, revisionID, _ref5$simd, simd, _ref5$executionPrefer, executionPreference, executionQuantaPreference, _ref5$usagePreference, usagePreference, _ref5$estimatorBudget, estimatorBudget, _ref5$paths, paths, thresholds, executionSpec, assetConfig, updatedFetchBehavior, fetchConfig, executionDefinition, useSIMD, processor, variant, executionQuanta, model, startingURL;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _ref4 = options || {}, fetchBehavior = _ref4.fetchBehavior, preResolve = _ref4.preResolve, logger = _ref4.logger;
                _ref5 = spec || {}, _ref5$category = _ref5.category, category = _ref5$category === void 0 ? 'voicefocus' : _ref5$category, _ref5$name = _ref5.name, name = _ref5$name === void 0 ? 'default' : _ref5$name, _ref5$variant = _ref5.variant, variantPreference = _ref5$variant === void 0 ? 'auto' : _ref5$variant, _ref5$assetGroup = _ref5.assetGroup, assetGroup = _ref5$assetGroup === void 0 ? DEFAULT_ASSET_GROUP : _ref5$assetGroup, revisionID = _ref5.revisionID, _ref5$simd = _ref5.simd, simd = _ref5$simd === void 0 ? 'detect' : _ref5$simd, _ref5$executionPrefer = _ref5.executionPreference, executionPreference = _ref5$executionPrefer === void 0 ? 'auto' : _ref5$executionPrefer, executionQuantaPreference = _ref5.executionQuantaPreference, _ref5$usagePreference = _ref5.usagePreference, usagePreference = _ref5$usagePreference === void 0 ? 'interactivity' : _ref5$usagePreference, _ref5$estimatorBudget = _ref5.estimatorBudget, estimatorBudget = _ref5$estimatorBudget === void 0 ? 100 : _ref5$estimatorBudget, _ref5$paths = _ref5.paths, paths = _ref5$paths === void 0 ? DEFAULT_PATHS : _ref5$paths, thresholds = _ref5.thresholds;
                logger === null || logger === void 0 ? void 0 : logger.debug('Configuring Voice Focus with spec', spec);

                if (!(category !== undefined && category !== 'voicefocus')) {
                  _context3.next = 5;
                  break;
                }

                throw new Error("Unrecognized category ".concat(category));

              case 5:
                if (!(name !== undefined && name !== 'default' && name !== 'ns_es')) {
                  _context3.next = 7;
                  break;
                }

                throw new Error("Unrecognized feature name ".concat(name));

              case 7:
                if (!(variantPreference !== undefined && !['auto', 'c100', 'c50', 'c20', 'c10'].includes(variantPreference))) {
                  _context3.next = 9;
                  break;
                }

                throw new Error("Unrecognized feature variant ".concat(variantPreference));

              case 9:
                if (!(executionQuantaPreference !== undefined && ![1, 2, 3].includes(executionQuantaPreference))) {
                  _context3.next = 11;
                  break;
                }

                throw new Error("Unrecognized execution quanta preference ".concat(executionQuantaPreference));

              case 11:
                validateAssetSpec(assetGroup, revisionID);

                if (!(simd !== undefined && !['detect', 'force', 'disable'].includes(simd))) {
                  _context3.next = 14;
                  break;
                }

                throw new Error("Unrecognized SIMD option ".concat(simd));

              case 14:
                if (!(executionPreference !== undefined && !['auto', 'inline', 'worker', 'worker-sab', 'worker-postMessage'].includes(executionPreference))) {
                  _context3.next = 16;
                  break;
                }

                throw new Error("Unrecognized execution preference ".concat(executionPreference));

              case 16:
                if (!(usagePreference !== undefined && !['quality', 'interactivity'].includes(usagePreference))) {
                  _context3.next = 18;
                  break;
                }

                throw new Error("Unrecognized usage preference ".concat(usagePreference));

              case 18:
                executionSpec = {
                  executionPreference: this.mungeExecutionPreference(executionPreference, logger),
                  usagePreference: usagePreference,
                  executionQuantaPreference: executionQuantaPreference,
                  variantPreference: variantPreference,
                  namePreference: name,
                  simdPreference: simd,
                  estimatorBudget: estimatorBudget
                };
                assetConfig = revisionID ? {
                  revisionID: revisionID
                } : {
                  assetGroup: assetGroup
                };
                updatedFetchBehavior = fetch_js_1.addQueryParams(fetchBehavior, assetConfig);
                fetchConfig = Object.assign({
                  paths: paths
                }, updatedFetchBehavior);
                _context3.next = 24;
                return decider_js_1.measureAndDecideExecutionApproach(executionSpec, fetchConfig, logger, thresholds);

              case 24:
                executionDefinition = _context3.sent;

                if (!(executionDefinition.supported === false)) {
                  _context3.next = 27;
                  break;
                }

                return _context3.abrupt("return", {
                  supported: false,
                  reason: executionDefinition.reason
                });

              case 27:
                logger === null || logger === void 0 ? void 0 : logger.info('Decided execution approach', executionDefinition);
                useSIMD = executionDefinition.useSIMD, processor = executionDefinition.processor, variant = executionDefinition.variant, executionQuanta = executionDefinition.executionQuanta;
                model = {
                  category: category || 'voicefocus',
                  name: name || 'default',
                  variant: variant,
                  simd: useSIMD
                };

                if (!preResolve) {
                  _context3.next = 35;
                  break;
                }

                startingURL = urlForModel(model, paths);
                _context3.next = 34;
                return fetch_js_1.resolveURL(startingURL, updatedFetchBehavior);

              case 34:
                model.url = _context3.sent;

              case 35:
                return _context3.abrupt("return", {
                  fetchConfig: fetchConfig,
                  model: model,
                  processor: processor,
                  executionQuanta: executionQuanta,
                  supported: true
                });

              case 36:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "init",
    value: function init(configuration, _ref6) {
      var delegate = _ref6.delegate,
          _ref6$preload = _ref6.preload,
          preload = _ref6$preload === void 0 ? true : _ref6$preload,
          logger = _ref6.logger;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var model, processor, fetchConfig, executionQuanta, simd, name, paths, modelURL, audioBufferURL, resamplerURL, workerURL, _PROCESSORS$processor, file, node, processorURL, worker, message, numberOfInputs, nodeOptions, factory;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(configuration.supported === false)) {
                  _context4.next = 2;
                  break;
                }

                throw new Error('Voice Focus not supported. Reason: ' + configuration.reason);

              case 2:
                model = configuration.model, processor = configuration.processor, fetchConfig = configuration.fetchConfig, executionQuanta = configuration.executionQuanta;
                simd = model.simd, name = model.name;
                paths = fetchConfig.paths;

                if (!(processor !== 'voicefocus-inline-processor' && processor !== 'voicefocus-worker-postMessage-processor' && processor !== 'voicefocus-worker-sab-processor')) {
                  _context4.next = 7;
                  break;
                }

                throw new Error("Unknown processor ".concat(processor));

              case 7:
                modelURL = model.url || urlForModel(model, paths);
                logger === null || logger === void 0 ? void 0 : logger.debug("Using model URL ".concat(modelURL, "."));
                audioBufferURL = "".concat(paths.wasm, "audio_buffer-v1").concat(simd ? '_simd' : '', ".wasm");
                resamplerURL = "".concat(paths.wasm, "resampler-v1").concat(simd ? '_simd' : '', ".wasm");
                workerURL = "".concat(paths.workers, "worker-v1.js");
                _PROCESSORS$processor = PROCESSORS[processor], file = _PROCESSORS$processor.file, node = _PROCESSORS$processor.node;
                processorURL = "".concat(paths.processors).concat(file);
                _context4.next = 16;
                return loader_js_1.loadWorker(workerURL, 'VoiceFocusWorker', fetchConfig, logger);

              case 16:
                worker = _context4.sent;

                if (preload) {
                  logger === null || logger === void 0 ? void 0 : logger.debug('Preloading', modelURL);
                  message = support_js_1.supportsWASMPostMessage(globalThis) ? 'get-module' : 'get-module-buffer';
                  worker.postMessage({
                    message: message,
                    preload: true,
                    key: 'model',
                    fetchBehavior: fetchConfig,
                    path: modelURL
                  });
                }

                numberOfInputs = name === 'ns_es' ? 2 : 1;
                nodeOptions = {
                  processor: processor,
                  worker: worker,
                  audioBufferURL: audioBufferURL,
                  resamplerURL: resamplerURL,
                  fetchBehavior: fetchConfig,
                  modelURL: modelURL,
                  delegate: delegate,
                  logger: logger,
                  numberOfInputs: numberOfInputs
                };
                factory = new VoiceFocus(worker, processorURL, node, nodeOptions, executionQuanta);
                return _context4.abrupt("return", Promise.resolve(factory));

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
  }]);

  return VoiceFocus;
}();

exports.VoiceFocus = VoiceFocus;

var createAudioContext = function createAudioContext() {
  var contextHint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_CONTEXT_HINT;
  return new (window.AudioContext || window.webkitAudioContext)(contextHint);
};

exports.createAudioContext = createAudioContext;

var getAudioInput = function getAudioInput(context, inputOptions, voiceFocusOptions) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee5() {
    var _a, _b, constraints, spec, delegate, _inputOptions$preload, preload, options, logger, config, factory, agc, input;

    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            constraints = inputOptions.constraints, spec = inputOptions.spec, delegate = inputOptions.delegate, _inputOptions$preload = inputOptions.preload, preload = _inputOptions$preload === void 0 ? true : _inputOptions$preload, options = inputOptions.options;
            logger = voiceFocusOptions.logger;
            _context5.next = 4;
            return VoiceFocus.configure(spec, voiceFocusOptions);

          case 4:
            config = _context5.sent;

            if (config.supported) {
              _context5.next = 8;
              break;
            }

            (_a = voiceFocusOptions.logger) === null || _a === void 0 ? void 0 : _a.warn('Voice Focus not supported; returning standard stream.');
            return _context5.abrupt("return", window.navigator.mediaDevices.getUserMedia(constraints));

          case 8:
            _context5.next = 10;
            return VoiceFocus.init(config, {
              delegate: delegate,
              preload: preload,
              logger: logger
            });

          case 10:
            factory = _context5.sent;
            agc = ((_b = inputOptions.options) === null || _b === void 0 ? void 0 : _b.agc) || DEFAULT_AGC_SETTING;
            _context5.next = 14;
            return window.navigator.mediaDevices.getUserMedia(mungeConstraints(constraints, agc));

          case 14:
            input = _context5.sent;
            return _context5.abrupt("return", factory.applyToStream(input, context, options).then(function (result) {
              return result.stream;
            }));

          case 16:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
};

exports.getAudioInput = getAudioInput;